import discount from './discount'
import payment from './payment'
import tariff from './tariff'
import account from './account'
import commercialBanking from './commercial-banking/index'
import wallet from './wallet/index'

export default {
  name: 'Financial',
  path: 'financial',
  meta: {
    label: 'financial',
    auth: 'financial'
  },
  component: {
    name: 'Financial',
    render(c) {
      return c('router-view')
    }
  },
  children: [discount, payment, tariff, account, commercialBanking, wallet]
}
